import { useAppLayout } from "@dataone/lib";
import { useState, useEffect } from "react";
import { styled } from "styled-components";
import SmartSearchTab from "./components/smart-search-tab/SmartSearchTab";
import { useSmartSearch } from "./contexts/smart-search.provider";
import { ChevronDoubleIcon } from "@dataone/icons";
import AnimatedScroll from "../../layout/header/AnimatesScroll";

const SmartSearchApp = () => {
  const [isShrinking, setShrinking] = useState(false);
  const [animationStarted, setAnimationStarted] = useState(false);
  const { showResponse, setShowResponse } = useSmartSearch();
  const { isSmartSearchVisible, isResponseVisible } = useAppLayout();
  const [showDocumentsViewer, setShowDocumentsViewer] = useState(false);
  const [docQuestion, setDocQuestion] = useState<string>("");

  useEffect(() => {
    if (!isResponseVisible) {
      setShowResponse(false);
      setShowDocumentsViewer(false);
    }
  }, [isResponseVisible, showResponse]);

  const hideSmartSearch = () => {
    setShrinking(true);
    setTimeout(() => {
      useAppLayout.setState({ isSmartSearchVisible: false });
      useAppLayout.setState({ isResponseVisible: false });
      setShrinking(false);
    }, 400);
  };

  const handleAnimationStart = () => {
    setTimeout(() => {
      setAnimationStarted(true);
    }, 200);
  };

  if (isSmartSearchVisible)
    return (
      <StyledSmartSearch
        $isShrinking={isShrinking}
        onAnimationStart={handleAnimationStart}
        id="smartsearch-modal"
      >
        {animationStarted && !isShrinking && !showDocumentsViewer && (
          <StyledContainer>
            <SmartSearchTab
              showResponse={showResponse}
              setShowResponse={setShowResponse}
              setShowDocumentsViewer={setShowDocumentsViewer}
              setDocQuestion={setDocQuestion}
            />
            {/* {showResponse && <DatabasesList />} */}
          </StyledContainer>
        )}
        <StyledIcon onClick={hideSmartSearch}>
          <AnimatedScroll />
        </StyledIcon>
      </StyledSmartSearch>
    );
  return <></>;
};

export default SmartSearchApp;

const StyledSmartSearch = styled.div<{ $isShrinking: boolean }>`
  .ant-modal {
    // max-width: 80% !important;
    max-width: 95% !important;
    width: auto !important;
  }
  position: absolute;
  z-index: 100;
  width: 100%;
  height: 100%;
  // backdrop-filter: blur(25px);
  // background: linear-gradient(180deg, #eff1fd 0%, #fffd 10%);
  border-radius: 20px 40px 40px 40px;
  background: #fff;
  overflow: hidden;
  ${({ $isShrinking }) =>
    $isShrinking
      ? "-webkit-animation: shrink 0.5s forwards;"
      : "-webkit-animation: expand 0.5s;"}

  @-webkit-keyframes expand {
    0% {
      height: 0px;
    }
    100% {
      height: 100%;
    }
  }

  @-webkit-keyframes shrink {
    0% {
      height: 100%;
    }
    100% {
      height: 0px;
    }
  }
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledIcon = styled.div`
  font-size: 10px;
  cursor: pointer;
  transform: scale(2) rotate(-90deg);
  position: absolute;
  bottom: 6px;
  left: calc(50% - 10px);
  &:hover {
    opacity: 0.8;
  }
  height: 11px;
`;
